const WORKSPACE_STATUSES = {
    OPEN: 'OPEN',
    CLOSED: 'CLOSED',
    EMPLOYEE_REVIEW: 'EMPLOYEE_REVIEW'
};

export default WORKSPACE_STATUSES;